<template>
    <DialogChoice 
        title="'New&nbsp;Flow'" 
        message="Ready to start something new? Find your current flow in your library."
        firstLabel="Cancel"
        firstColor="surface"
        secondLabel="Continue"
        secondColor="color1"
        :onSecond="handleRestart">
    </DialogChoice>
</template>

<script>
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import { DialogChoice } from '@generio-ai/library-legacy/components/dialogs'

export default {
    name: 'DialogRestart',
    components: {
        DialogChoice
    },
    props: {
        app: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions('flows', [
			'newFlow',
        ]),
        handleRestart() {
            this.newFlow({
				app: this.app
			})
        }
    }
}
</script>